export default {
      id: "money-transfer-usage",
      viewBox: "0 0 129 111",
      url: __webpack_public_path__ + "icons-sprite.626747e.svg#money-transfer-usage",
      toString: function () {
        return this.url;
      }
    }